"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Message = exports.DragDropUpload = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utilities = _interopRequireDefault(require("../../utilities/utilities"));
var _dragDropModule = _interopRequireDefault(require("./dragDrop.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var isAdvancedUpload = false;
var DragDropUpload = exports.DragDropUpload = /*#__PURE__*/function (_Component) {
  function DragDropUpload() {
    var _this;
    _classCallCheck(this, DragDropUpload);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DragDropUpload, [].concat(args));
    _defineProperty(_this, "state", {
      active: false,
      isAdvancedUpload: false
    });
    _defineProperty(_this, "window", window);
    _defineProperty(_this, "onDragOver", function (e) {
      _this.setState({
        active: true
      });
      e.dataTransfer.dropEffect = "copy";
      e.preventDefault();
    });
    _defineProperty(_this, "onDragLeave", function (e) {
      e.preventDefault();
      _this.setState({
        active: false
      });
    });
    _defineProperty(_this, "handleChange", function (e) {
      var file = e.target.files[0];
      if (typeof file !== "undefined") {
        if (_this.extensionIsAllowed(file)) {
          _this.props.fileChange(file);
        } else {
          var extension = _utilities["default"].getUrlExtension(file === null || file === void 0 ? void 0 : file.name);
          _this.props.onError && _this.props.onError("Error: file type \"".concat(extension, "\" is not allowed"));
        }
      }
      _this.setState({
        active: false
      });
    });
    _defineProperty(_this, "handleClick", function (e) {
      if (_this.props.disabled) {
        return false;
      }
      _this.clearTarget(e);
    });
    _defineProperty(_this, "onDrop", function (e) {
      e.preventDefault();
      if (_this.props.disabled) return false;
      var uploadObj = {
        target: e.nativeEvent.dataTransfer
      };
      _this.handleChange(uploadObj);
    });
    _defineProperty(_this, "renderUploading", function () {
      if (!_this.props.uploading) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, _this.parseChildren());
    });
    _defineProperty(_this, "renderContent", function () {
      var _this$props = _this.props,
        id = _this$props.id,
        name = _this$props.name,
        uploading = _this$props.uploading;
      if (uploading) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
        type: "file",
        id: id,
        name: "".concat(name, "[]"),
        accept: _this.prepareAcceptList(),
        onChange: _this.handleChange,
        onClick: _this.handleClick
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: id,
        onDrop: _this.onDrop,
        onDragOver: _this.onDragOver,
        onDragLeave: _this.onDragLeave
      }, /*#__PURE__*/_react["default"].createElement("div", null, _this.parseChildren())));
    });
    return _this;
  }
  _inherits(DragDropUpload, _Component);
  return _createClass(DragDropUpload, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setIsAdvancedUpload();

      //prevent the browser from loading the file if the drop area is missed
      this.window.addEventListener("dragover", DragDropUpload.bodyOnDrop);
      this.window.addEventListener("drop", DragDropUpload.bodyOnDrop);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.window.removeEventListener("dragover", DragDropUpload.bodyOnDrop);
      this.window.removeEventListener("drop", DragDropUpload.bodyOnDrop);
    }

    /* istanbul ignore next */
  }, {
    key: "setIsAdvancedUpload",
    value: function setIsAdvancedUpload() {
      isAdvancedUpload = function () {
        var div = document.createElement("div");
        var draggable = "draggable" in div;
        var dragStartAndDrop = "ondragstart" in div && "ondrop" in div;
        var formData = "FormData" in window;
        var fileReader = "FileReader" in window;
        return (draggable || dragStartAndDrop) && formData && fileReader;
      }();
      this.setState({
        isAdvancedUpload: isAdvancedUpload
      });
    }
  }, {
    key: "extensionIsAllowed",
    value: function extensionIsAllowed(file) {
      var extension = _utilities["default"].getUrlExtension(file === null || file === void 0 ? void 0 : file.name);
      return !this.props.accept || this.props.accept.indexOf(extension) >= 0;
    }
  }, {
    key: "clearTarget",
    value: function clearTarget(e) {
      if (this.props.clearOnClick) {
        e.target.value = null;
      }
    }
  }, {
    key: "prepareAcceptList",
    value: function prepareAcceptList() {
      var accept = this.props.accept;
      if (accept && Array.isArray(accept)) {
        return "." + accept.join(", .");
      }
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      return "".concat(_dragDropModule["default"].dragDrop, " ").concat(this.state.active && _dragDropModule["default"].active);
    }
  }, {
    key: "shouldRenderMessage",
    value: function shouldRenderMessage(element) {
      if (this.props.uploading) {
        return element.props.messageType === "Uploading";
      }
      return element.props.messageType === "Advanced" && this.state.isAdvancedUpload || element.props.messageType === "Standard" && !this.state.isAdvancedUpload;
    }
  }, {
    key: "parseChildren",
    value: function parseChildren() {
      var _this2 = this;
      return _react["default"].Children.map(this.props.children, function (element) {
        return _this2.shouldRenderMessage(element) ? element : null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "drag-drop-upload",
        className: this.getClassName()
      }, this.renderUploading(), this.renderContent()));
    }
  }], [{
    key: "bodyOnDrop",
    value: function bodyOnDrop(e) {
      e.preventDefault();
    }
  }]);
}(_react.Component);
var Message = exports.Message = function Message(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-message-type": props.messageType
  }, props.children);
};
Message.propTypes = {
  messageType: _propTypes["default"].oneOf(["Standard", "Advanced", "Uploading"]).isRequired
};
DragDropUpload.propTypes = {
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  fileChange: _propTypes["default"].func.isRequired,
  onError: _propTypes["default"].func,
  accept: _propTypes["default"].array,
  clearOnClick: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  uploading: _propTypes["default"].bool
};
DragDropUpload.defaultProps = {
  clearOnClick: false,
  uploading: false
};
var _default = exports["default"] = DragDropUpload;